module.exports = __webpack_public_path__ + "img/WechatIMG14.4e515c22.png";